enum TabMode {
    ITEMS = 0,
    DOCUMENTS = 1,
    SETTINGS = 2,
}

export default TabMode;